
import { getApiBaseUrl } from "../util";

export function findAll() {

    const url = getApiBaseUrl() + '/api/overview/countries';

    return fetch(url,
    {
        method: 'get'
    });
}